import PropTypes from "prop-types";
import { Horizontal } from "./styles";

const FRAMED_CLASSNAME =
  "p-16 border border-neutral-20 rounded-4 bg-neutral-10";

// When `isUnframed` is set, the component drops its own border/background so it
// can sit inside an outer container (e.g. a design-system Card) without a double
// frame, while keeping the horizontal grid layout. Defaults to framed so every
// existing caller renders exactly as before.
export const Aligned = ({ isHorizontalComponent, isUnframed, children }) => {
  if (isUnframed) {
    return (
      <div
        className={isHorizontalComponent ? "grid grid-cols-3 gap-8" : undefined}
      >
        {children}
      </div>
    );
  }

  const Component = isHorizontalComponent ? Horizontal : "div";
  return (
    <Component
      className={!isHorizontalComponent ? FRAMED_CLASSNAME : undefined}
    >
      {children}
    </Component>
  );
};

Aligned.propTypes = {
  isHorizontalComponent: PropTypes.bool.isRequired,
  isUnframed: PropTypes.bool,
  children: PropTypes.node.isRequired,
};
